import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import React, { FC, useEffect, useState, } from 'react';
import handleError from '../../utils/handleError';
import Manual3PL from './components/manual3PL';
import Report from './components/report';
import SubmitFile from './components/submitfile';
import Suggested3PL from './components/suggested3PL';

interface Props {
  history: any
}

type State = "MANUAL" | "SUGGESTED" | "UPLOAD" | "REPORT";

interface Errors {
  code: number;
  text: string;
}

const GroupingCreateOrder: FC<Props> = ({ history }: Props): React.ReactElement => {
  const [data, setData] = useState();
  const [state, setState] = useState<State>("UPLOAD");
  const [selected3pl, setSelected3pl] = useState<number[]>([]);
  const [tpls, setTpls] = useState<any[]>([]);

  const get3PLs = async () => {
    const payload = {
      body: {
        "status.equals": "ACTIVE"
      }
    }
    try {
      const { response } = await ordersRepository.get3PLs({ payload });
      setTpls(response.data)
    } catch (err) {
      handleError(err)
    }
  }

  useEffect(() => {
    get3PLs()
  }, [data])

  const componentMap = {
    MANUAL: <Manual3PL setData={setData} data={data} setState={setState} selected={selected3pl} tpls={tpls} />,
    SUGGESTED: <Suggested3PL setData={setData} data={data} setState={setState} selected={selected3pl} tpls={tpls} />,
    UPLOAD: <SubmitFile setData={setData} setState={setState} selected={selected3pl} select={setSelected3pl} />,
    REPORT: <Report data={data} setData={setData} setState={setState} />
  }

  return (
    <React.Fragment>
      {componentMap[state]}
    </React.Fragment>
  );
};

export default GroupingCreateOrder;